/**
 * A function to download a text field
 * @param filename - the name of the file you want to download
 * @param text - The text of the file
 */
export const download = (filename: string, text: string): void => {
  const element = document.createElement("a");
  element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};
